const body = document.querySelector('body');
class FixedSideScrollBar extends HTMLElement {
  constructor() {
    super();
    this.point = this.querySelector('.point');
    this.anchors = this.querySelectorAll('[data-to]');
    this.topClass = this.dataset.topClass || null;
    this.intersects = document.querySelectorAll('.should-intersect');
    this.intersection.bind(this);
    this.currentActive = 'top';
    this.intersection();

    this.anchors.forEach(anchor => 
      anchor.addEventListener('click', () => {
        document.querySelector('body').classList.add('scrolling');
        this.setPointPosition(anchor, true);
      })
    );

    window.addEventListener('resize', () => {
      if(window.innerWidth > 768) {
        this.point.style.left = '-6px';
      } 
    });
  };


  intersection() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // If the element is the top element
          if(entry.target.classList.contains(this.topClass)) {
            this.currentActive = `.${this.topClass}`;
            this.setPointPosition(document.querySelector(this.currentActive), false);
            return;
          } 

          // Anchors from the scrollbar
          this.anchors.forEach(anchor => {
            if (anchor.dataset.to.replace('#', '') === entry.target.id) {
              this.currentActive = anchor.dataset.to;

              this.setPointPosition(anchor, false);
            }
          });
        }
      });
    }, {threshold: 0.5});

    this.intersects.forEach(intersect => observer.observe(intersect));
  };

  setPointPosition(anchor, scroll) {
    if(!anchor) return;

    const direction = window.innerWidth > 768 ? 'top' : 'left';
    let offset = anchor.classList.contains(this.topClass) ? 0 
      : direction === 'top' ? anchor.offsetTop : anchor.offsetLeft + 15;
    this.point.style[direction] = `${offset}px`;
    this.anchors.forEach(anchor => anchor.classList.remove('active'));
    anchor.classList?.add('active');

    if(!scroll) return;

    document.querySelector(anchor.dataset.to).scrollIntoView({ 
      behavior: 'smooth',
      offsetTop: '-200px'
    });

    setTimeout(() => {
      document.querySelector('body').classList.remove('scrolling');
    }, 1500);
  };
}

window.customElements.define("fixed-side-scrollbar", FixedSideScrollBar);



class VideoContainer extends HTMLElement {
  constructor() {
    super();
    this.dataset.playing = false;
    this.video = this.querySelector('video');
    this.iframe = this.querySelector('iframe');
    this.setVideoOptions();
    this.scrollLockEvents();
  }

  setVideoOptions() {
    // set class to video container depending on aspect ratio
    const aspectRatio = this.video.videoHeight / this.video.videoWidth;
    if(aspectRatio < 1) {
      this.classList.add('wide');
    } else {
      this.classList.add('tall');
    }

    //create video wrapper
    this.videoWrapper = document.createElement('div');
    this.videoWrapper.classList.add('video-wrapper');
    this.appendChild(this.videoWrapper);
    this.videoWrapper.appendChild(this.video);
    this.insertAdjacentElement('afterbegin', this.videoWrapper);

    // Create play and close buttons
    this.playButton = document.createElement('div');
    // add image to playButton div
    this.playButton.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/2090/8057/files/play_button_2.webp?v=1676597759" alt="Play button">';
    this.playButton.classList.add('play-button');
    this.closeButton = document.createElement('div');
    this.closeButton.classList.add('close-button');
    this.closeButton.innerHTML = 'X';
    this.closeButton.classList.add('hidden');
    
    this.videoWrapper.appendChild(this.playButton);
    this.videoWrapper.appendChild(this.closeButton);

    this.preOpenStyles = this.style

    this.playButton.addEventListener('click', () => this.play());
    this.closeButton.addEventListener('click', () => this.close());
  }

  setClose() {
    this.addEventListener('click', this.handleClickClose);
    // document.addEventListener('keydown', this.handleEscapeClose);
  }

  removeClose() {
    this.removeEventListener('click', this.handleClickClose);
    // document.removeEventListener('keydown', e => {this.handleEscapeClose(e, vid).bind(this)});
  }

  handleClickClose(e) {
    if(e.target.tagName === 'VIDEO-CONTAINER') this.close();
  }

  // TODO ENHANCEMENT: Fix this
  // handleEscapeClose(e, vid) {
  //   if(e.key === 'Escape') {
  //     vid.close();
  //   }
  // }

  scrollLockEvents() {
    this.video.addEventListener('play', () => {
      document.body.style.overflow = 'hidden';
    });

    this.video.addEventListener('pause', () => {
      document.body.style.overflow = 'auto';
    });
  }

  play() {
    this.style.margin = '0';
    this.style.padding = '0';
    this.parentElement.classList.add('videoPopUpOpen');
    this.video.play();
    this.video.setAttribute('controls', true);
    this.dataset.playing = true;
    this.playButton.classList.add('hidden');
    this.closeButton.classList.remove('hidden');
    setTimeout(() => this.setClose(), 1000);
  }

  close() {
    this.style = this.preOpenStyles;
    this.parentElement.classList.remove('videoPopUpOpen');
    this.video.pause();
    this.video.removeAttribute('controls');
    this.dataset.playing = false;
    this.playButton.classList.remove('hidden');
    this.closeButton.classList.add('hidden');
  }
} 

customElements.define('video-container', VideoContainer);

class ImagePopup extends HTMLElement {
  constructor() {
    super();
    this.dataset.open = false;
    this.image = this.querySelector('img');
    this.imageDecorative = this.querySelector('.bs-decorative_image');
    this.content = this.querySelector('p');
    this.setImageOptions();
    this.parentMoving = false;

    this.addEventListener('mousemove', e => this.parentMoving = true);
    this.addEventListener('mousedown', e => this.parentMoving = false);
  }

  setImageOptions() {
    // set aspect ratio class of the image
    const aspectRatio = this.image.naturalHeight / this.image.naturalWidth;
    if(aspectRatio < 1) {
      this.classList.add('image-wide');
    } else {
      this.classList.add('image-tall');
    }
    //create video wrapper if it doesn't exist
    this.imageWrapper = document.createElement('div');
    this.imageWrapper.classList.add('image-wrapper');
    this.appendChild(this.imageWrapper);
    this.imageWrapper.appendChild(this.image);
    if(this.imageDecorative)
      this.imageWrapper.appendChild(this.imageDecorative);
    if(this.content) this.imageWrapper.appendChild(this.content);
    this.insertAdjacentElement('afterbegin', this.imageWrapper)

    // Create close buttons
    this.closeButton = document.createElement('button');
    this.closeButton.classList.add('close-button');
    this.closeButton.innerHTML = 'X';
    this.closeButton.classList.add('hidden');
    
    this.imageWrapper.appendChild(this.closeButton);

    this.closeButton.addEventListener('click', () => {
      this.close();
    });

    this.addEventListener('mouseup', this.open);
  }

  setClose() {
    this.addEventListener('click', this.handleClickClose);
    // document.addEventListener('keydown', this.handleEscapeClose);
  }

  removeClose() {
    this.removeEventListener('click', this.handleClickClose);
    // document.removeEventListener('keydown', e => {this.handleEscapeClose(e, vid).bind(this)});
  }

  handleClickClose(e) {
    if(e.target.tagName === 'IMAGE-POPUP') this.close();
  }

  // TODO ENHANCEMENT: Fix this
  // handleEscapeClose(e, vid) {
  //   if(e.key === 'Escape') {
  //     vid.close();
  //   }
  // }

  open(e) {
    if(this.parentMoving) return;
    this.parentMoving = false;
    
    if(e.target.classList.contains('close-button')) return;
    
    this.parentElement.classList.add('imagePopupOpen');
    document.body.style.overflow = 'hidden';
    this.dataset.open = true;
    this.closeButton.classList.remove('hidden');
    setTimeout(() => this.setClose(), 1000);
  }

  close() {
    this.parentElement.classList.remove('imagePopupOpen');
    document.body.style.overflow = 'auto';
    this.dataset.open = false;
    this.closeButton.classList.add('hidden');
  }
} 

customElements.define('image-popup', ImagePopup);


// create a draggable slider

class DraggableSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = document.createElement('div');
    this.slider.classList.add('slider');
    
    this.sliderInner = document.createElement('div');
    this.sliderInner.classList.add('slider-inner');
    
    Array.from(this.children).forEach((child) => {
      this.sliderInner.appendChild(child);
    });
    
    this.slider.appendChild(this.sliderInner);
    this.appendChild(this.slider);

    this.isDragging = false;
    this.currentX = 0;
    this.initialX = 0;
    this.initialY = 0;
    this.xOffset = 0;
    this.previousTouch = null;

    this.sliderInner.addEventListener("mousedown", this.dragStart.bind(this));
    this.sliderInner.addEventListener("mouseup", this.dragEnd.bind(this));
    this.sliderInner.addEventListener("mouseleave", this.dragEnd.bind(this));
    this.sliderInner.addEventListener("mousemove", this.drag.bind(this));

    this.sliderInner.addEventListener("touchstart", this.dragStart.bind(this));
    this.sliderInner.addEventListener("touchend", this.dragEnd.bind(this));
    this.sliderInner.addEventListener("touchmove", this.drag.bind(this));
  }

  dragStart(e) {
    if (e.type === "mousedown") {
      this.initialX = e.pageX - this.slider.offsetLeft;
    } else if (e.type === "touchstart") {
      this.initialX = e.touches[0].clientX - this.slider.offsetLeft;
      this.initialY = e.touches[0].clientY;
    }

    this.isDragging = true;
  }

  dragEnd(e) {
    if (e.type === "mouseup" || e.type === "mouseleave") {
      this.currentX = e.pageX - this.slider.offsetLeft;
    } else if (e.type === "touchend") {
      this.currentX = e.changedTouches[0].clientX - this.slider.offsetLeft;
    }
    this.sliderInner.style.cursor = "grab";
    this.isDragging = false;
  }

  drag(e) {
    if (!this.isDragging) return;

    let isTouch = e.type === "touchmove";
    if(!isTouch) {
      e.preventDefault();
    } else {
      const deltaX = (isTouch ? e.touches[0].clientX : e.clientX) - this.currentX;
      const deltaY = (isTouch ? e.touches[0].clientY : e.clientY) - this.initialY;
      // If the vertical distance is greater than the horizontal distance, allow vertical scrolling
      if (Math.abs(deltaY) > Math.abs(deltaX)) {
        return;
      }
    }

    this.sliderInner.style.cursor = "grabbing";
    if (e.type === "mousemove") {
      this.currentX = e.pageX - this.slider.offsetLeft;
    } else if (e.type === "touchmove") {
      this.currentX = e.touches[0].clientX - this.slider.offsetLeft;
    }
    this.xOffset = this.currentX - this.initialX;
    this.sliderInner.style.left = (parseInt(this.sliderInner.style.left) || 0) + this.xOffset + "px";
    this.initialX = this.currentX;

    const sliderWidth = this.sliderInner.offsetWidth;
    const viewportWidth = this.sliderInner.parentElement.clientWidth;

    if (parseInt(this.sliderInner.style.left) > 0) {
      this.sliderInner.style.left = "0px";
      this.isDragging = false;
    } else if (Math.abs(parseInt(this.sliderInner.style.left)) >= sliderWidth - viewportWidth) {
      this.sliderInner.style.left =  `${viewportWidth - sliderWidth}px`;
      this.isDragging = false;
    }

    if(e.touches)
      this.previousTouch = e.touches[0];
  }
}

customElements.define('draggable-slider', DraggableSlider);
/*

How to use fillEvent:
  If [data-fill-attributes] is present on any element, 
  we'll apply on click events to each slide to fill information
  using the json on [data-fill] in the element with .swiper-slide.

  The json being sent will be used to search for data-[key] 
  attributes on an element inside [data-fill-attributes] wrapper
  
  Ex. { "title": "Example Title"} we'll search for dataset["title"] to fill the information 
  Element Example: <div data-step2="tag"></div>
  You can have data-xxx="tag" to add html to the element
  You can have data-xxx="href" to fill href attributes
  You can have data-xxx="src" to fill src attributes
  If you don't specify the data-xxx attribute, it will fill the innerHTML of the element
*/

if(typeof SwiperSliderFill == 'undefined') {
  class SwiperSliderFill extends HTMLElement {
    constructor() {
      console.log('creating-slider')
      super();
      this.swiper = null;
      this.fillEventElement = document.querySelector('[data-fill-attributes]')
      this.slidesPerView = this.getAttribute('slides-per-view') || 1;
      this.options = {
        // default options
        loop: true,
        navigation: {},
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
        },
        slidesPerView: this.slidesPerView,
      };
    }
  
    connectedCallback() {
      // load Swiper library if it's not already loaded
      if (typeof Swiper === 'undefined') {
        const css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
        css.onload = this.initSwiper.bind(this);
        document.head.appendChild(css);
  
        const js = document.createElement('script');
        js.src = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
        js.onload = this.initSwiper.bind(this);
        document.head.appendChild(js);
      } else {
        this.initSwiper();
      }
    }
  
    disconnectedCallback() {
      // destroy swiper slider when custom element is removed from DOM
      this.swiper.destroy();
    }
  
    initSwiper() {
      if(typeof Swiper === 'undefined') return;
      // create swiper container and wrapper elements
      const container = document.createElement('div');
      container.classList.add('swiper-container');
      const wrapper = document.createElement('div');
      wrapper.classList.add('swiper-wrapper');
  
      // add slides to wrapper element
      const slides = this.querySelectorAll('[data-slide]');
      slides.forEach((slide) => {
        slide.classList.add('swiper-slide');
        wrapper.appendChild(slide);
      });
  
      // append container and wrapper elements to custom element
      container.appendChild(wrapper);
      this.appendChild(container);
  
      // initialize swiper slider
      this.swiper = new Swiper(container, this.options);
  
      if(this.swiper && this.fillEventElement) {
        this.fillEvent(slides);
        console.log('adding Events')
          this.swiper.on('slideNextTransitionStart', () => {
            // click current slide
            const slide = this.querySelector('.swiper-slide-active');
            slide.click();
          });
      }
    }
  
    decodeHTMLEntities(encodedString) {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = encodedString;
      return tempElement.textContent;
    }
  
    fillEvent(slides) {
      console.log(slides)
      if(this.fillEventElement.classList.contains('hidden'))
        this.fillEventElement.classList.remove('hidden');
      slides.forEach(slide => {
        slide.addEventListener('click', () => {
          const f = JSON.parse(slide.dataset.fill);
          const fill = JSON.parse(slide.dataset.fill);
          
          Object.keys(fill).forEach(key => {
            const fillElement = this.decodeHTMLEntities(fill[key]);
            const element = this.fillEventElement.querySelector(`[data-${key}]`);
            if(element) {
              if(element.dataset[key] === 'tag') {
                element.innerHTML = fillElement;
              } else if(element.dataset[key] === 'href') {
                element.href = fillElement;
              } else if(element.dataset[key] === 'src') {
                element.src = fillElement;
                if(element.tagName === 'VIDEO' || element.tagName === 'SOURCE') {
                  let videoElement = element;
                  if(element.tagName === 'SOURCE') {
                    videoElement = element.parentElement;
                  }
                  videoElement.load();
                } 
              } else {
                element.innerHTML = fillElement;
              }
            }
          });
        });
      });
  
      slides[0].click();
    }
  
    static get observedAttributes() {
      return ['loop', 'navigation', 'breakpoints', 'slides-per-view', 'autoplay'];
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
      // update options when observed attributes change
      if (name === 'loop') {
        this.options.loop = newValue !== null;
      } else if (name === 'navigation') {
        this.options.navigation = newValue !== null ? {
          nextEl: '.input-icon-arrow-right',
          prevEl: '.input-icon-arrow-left',
        } : false;
      } else if (name === 'breakpoints') {
        this.options.breakpoints = JSON.parse(newValue);
      } else if (name === 'slides-per-view') {
        this.options.slidesPerView = parseInt(newValue);
      } else if (name === 'autoplay') {
        this.options.autoplay = newValue !== null ? {
          delay: parseInt(newValue),
        } : false;
      } 
  
      // reinitialize swiper slider with updated options
      if(this.swiper) {
        this.swiper.destroy();
        this.swiper = new Swiper(this.querySelector('.swiper-container'), this.options);
      }
    }
  }
  
  customElements.define('swiper-slider-fill', SwiperSliderFill);
}


class AccordionItem extends HTMLElement {
  constructor() {
    super();
    // set title and content elements
    this.heading = this.querySelector('[data-accordion-heading]');
    this.content = this.querySelector('[data-accordion-content]');
    
    // add click event listener to title element
    this.heading.addEventListener('click', () => {
      // get all accordion items in the same parent element
      const items = Array.from(this.parentElement.children)
        .filter(child => child.tagName === 'ACCORDION-ITEM');

      // close all other items
      items.forEach(item => {
        if (item !== this) {
          item.content.style.maxHeight = null;
          this.ariaLabel = 'collapsed';
          item.content.removeAttribute('open');
        }
      });
      // toggle this item
      if (this.content.hasAttribute('open')) {
        this.content.style.maxHeight = null;
        this.ariaLabel = 'collapsed';
        this.content.removeAttribute('open');
      } else {
        this.ariaLabel = 'expanded';
        this.content.style.maxHeight = this.content.scrollHeight + 'px';
        this.content.setAttribute('open', '');
      }
    });
  }
}

customElements.define('accordion-item', AccordionItem);